import { render, staticRenderFns } from "./table_import.vue?vue&type=template&id=454c6744&scoped=true&"
import script from "./table_import.vue?vue&type=script&lang=ts&"
export * from "./table_import.vue?vue&type=script&lang=ts&"
import style0 from "./table_import.vue?vue&type=style&index=0&id=454c6744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454c6744",
  null
  
)

export default component.exports